window.changeWidth = function (point, actionMobile, actionDesktop){
    const isType = (element) => {
        return {}.toString.call(element).slice(8, -1);
    };
    let mobileDevice = window.innerWidth < point;
    window.addEventListener('resize', () => {
        if(window.innerWidth < point && mobileDevice !== true) {
            if(isType(actionMobile) === 'Function') {
                actionMobile();
            }
            mobileDevice = true;
        } else if(window.innerWidth >= point && mobileDevice !== false) {
            if(isType(actionDesktop) === 'Function') {
                actionDesktop();
            }
            mobileDevice = false;
        }
    })
};



// WEBPACK FOOTER //
// ./libs/global/functions/functions.js